import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import PlankMobile from '@r1-frontend/ui-react/components/plankMobileUp/plankMobile';
import { isClientSide } from '@r1-frontend/shared/helpers/ssr';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import { isMobile } from '~/src/helpers/mobile';
import { TState } from '~/src/store';
import { hidePlank, initPlankStatus, setPlankCookieAndClose } from '~/src/store/actions/plank';

import * as ST from './styled';

const Plank: React.FC = () => {
    const dispatch = useDispatch();
    const router = useRouter();
    const { isShows, mobileLink, plankType } = useSelector((state: TState) => state.plank);
    const { pathname, asPath } = router;
    const [isHideByDevice, setIsHideByDevice] = useState(false);
    const isMobileWidth = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);

    useEffect(() => {
        dispatch(initPlankStatus({ asPath, pathname }));

        const res = (isClientSide() && isMobileWidth) ? !isMobile() : false;
        setIsHideByDevice(res);

        if (res) {
            dispatch(hidePlank());
        }
    }, [asPath, dispatch, pathname, isMobileWidth]);

    const handleClosePlank = useCallback((e) => {
        e.preventDefault();
        dispatch(setPlankCookieAndClose());
    }, [dispatch]);

    const handleCloseLink = useCallback((e) => {
        handleClosePlank(e);
        mobileLink && router.push(mobileLink);
    }, [handleClosePlank, mobileLink, router]);

    if (!isShows) {
        return null;
    }

    return <ST.PlankWrap id={'plankMobile'} isHide={isHideByDevice} isShows={isShows}>
        <PlankMobile
            {...plankType}
            isOpen={isShows}
            onCloseLink={handleCloseLink}
            onClosePlank={handleClosePlank}
        />
    </ST.PlankWrap>;
};

export default Plank;
